import React, { useEffect, createElement } from 'react';
import { CheckCircle, ArrowRight, Star, ShieldCheck, AlertTriangle, BookOpen, Clock, Target, X } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
const CHECKOUT_URL = 'https://payments.vantapro.shop/cart/44849402118246:1';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel Code - safe injection
    try {
      const w = window as any;
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(t);
      }
      w.fbq('init', '1379305313659580');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to load', e);
    }
  }, []);
  const handleCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  const CTAButton = ({
    text,
    subtext
  }: {
    text: string;
    subtext?: string;
  }) => <button onClick={handleCheckout} className="w-full max-w-2xl mx-auto block bg-cf-orange hover:bg-orange-600 text-white font-bold rounded-lg py-4 px-6 text-xl md:text-2xl shadow-[0_8px_0_rgb(194,65,12)] hover:shadow-[0_4px_0_rgb(194,65,12)] hover:translate-y-1 transition-all animate-pulse-glow" data-id="element-16">
      <div className="flex items-center justify-center gap-2" data-id="element-17">
        {text} <ArrowRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-18" />
      </div>
      {subtext && <p className="text-sm md:text-base font-normal mt-1 opacity-90" data-id="element-19">
          {subtext}
        </p>}
    </button>;
  return <div className="min-h-screen bg-gray-50 font-sans" data-id="element-20">
      <CountdownTimer data-id="element-21" />
      <SocialProofPopup data-id="element-22" />

      {/* HERO SECTION */}
      <section className="bg-white pt-4 pb-8 px-4 border-b-4 border-cf-darkblue" data-id="element-23">
        <div className="max-w-4xl mx-auto text-center" data-id="element-24">
          <p className="md:text-xl mb-2 uppercase tracking-wider text-[#070808] font-[700] text-[14px]" data-id="element-25">
            + de 2000 docentes ya lo usan ✅
          </p>

          <h1 className="text-[30px] font-black mb-3 leading-tight tracking-wide" data-id="element-26">
            <span className="text-black block text-[32px] md:text-[48px]" data-id="element-27">
              Mega Pack
            </span>
            <span className="text-[#2563EB] block text-[32px] md:text-[48px]" data-id="element-28">
              Matemática Secundaria
            </span>
          </h1>

          <div className="mb-4 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={handleCheckout} data-id="element-29">
            <img src="https://cdn.magicpatterns.com/uploads/c1PGSn6J9FHV8ASfQ3HvgX/Diseno_sin_titulo.png" alt="MegaPack Matemática Principal" className="w-full max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-30" />
          </div>

          <p className="text-xl md:text-2xl text-gray-700 font-medium mb-10 max-w-3xl mx-auto bg-yellow-100 p-4 rounded-lg border-l-4 border-yellow-400" data-id="element-31">
            Todo el material de Matemática que necesitás, listo para usar.
            Clases claras, organizadas y sin perder horas planificando.
          </p>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" subtext="Garantía de 7 días." data-id="element-32" />
        </div>
      </section>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-33">
        <div className="max-w-3xl mx-auto" data-id="element-34">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-35">
            Si enseñás Matemática, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-200" data-id="element-36">
            <h3 className="text-xl font-bold text-cf-red mb-6 text-center" data-id="element-37">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>

            <p className="text-lg mb-4" data-id="element-38">No porque no sepas Matemática.</p>
            <p className="text-lg mb-6" data-id="element-39">
              Sino porque cada semana parece empezar desde cero.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-40">
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-41">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-42" />{' '}
                Buscar ejercicios.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-43">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-44" />{' '}
                Pensar actividades.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-45">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-46" />{' '}
                Preparar evaluaciones.
              </li>
              <li className="flex items-center gap-3 text-lg text-gray-700" data-id="element-47">
                <AlertTriangle className="text-cf-red w-6 h-6 flex-shrink-0" data-id="element-48" />{' '}
                Ordenar material que está en distintos archivos.
              </li>
            </ul>

            <p className="text-xl font-bold text-center bg-gray-100 p-4 rounded" data-id="element-49">
              Y cuando entrás al aula… ya estás cansado.
            </p>
            <p className="text-center mt-4 text-gray-600 italic" data-id="element-50">
              Enseñar Matemática no debería sentirse así.
            </p>
          </div>
        </div>
      </section>

      {/* THE SILENT PROBLEM */}
      <section className="py-16 px-4 bg-cf-darkblue text-white" data-id="element-51">
        <div className="max-w-4xl mx-auto text-center" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-black mb-10 text-yellow-400" data-id="element-53">
            El problema silencioso
          </h2>

          <p className="text-xl mb-8" data-id="element-54">
            Muchos docentes pasan horas cada semana:
          </p>

          <div className="grid md:grid-cols-2 gap-6 text-left max-w-3xl mx-auto mb-10" data-id="element-55">
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-56">
              <ul className="space-y-4" data-id="element-57">
                <li className="flex items-start gap-3" data-id="element-58">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-59" />
                  <span className="text-lg" data-id="element-60">Planificando desde cero</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-61">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-62" />
                  <span className="text-lg" data-id="element-63">
                    Buscando ejercicios en distintos lugares
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white/10 p-6 rounded-lg" data-id="element-64">
              <ul className="space-y-4" data-id="element-65">
                <li className="flex items-start gap-3" data-id="element-66">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-67" />
                  <span className="text-lg" data-id="element-68">Usando material desordenado</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-69">
                  <X className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" data-id="element-70" />
                  <span className="text-lg" data-id="element-71">
                    Improvisando más de lo que les gustaría
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-cf-blue p-6 rounded-xl border-2 border-yellow-400 inline-block" data-id="element-72">
            <p className="text-xl md:text-2xl font-bold italic" data-id="element-73">
              Con esa sensación de:
              <br data-id="element-74" />
              "Podría dar mejores clases si tuviera todo el material listo."
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-75">
        <div className="max-w-4xl mx-auto text-center" data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-77">
            La solución:{' '}
            <span className="text-cf-blue" data-id="element-78">MegaPack Matemática</span>
          </h2>

          <p className="text-xl text-gray-700 mb-12 max-w-2xl mx-auto" data-id="element-79">
            Un sistema completo de recursos de Matemática organizado por año y
            por tema para que tus clases estén listas desde hoy.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12" data-id="element-80">
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-81">
              <BookOpen className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-82" />
              <p className="font-bold text-lg" data-id="element-83">📂 Abrís el material</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-84">
              <Target className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-85" />
              <p className="font-bold text-lg" data-id="element-86">👆 Elegís el tema</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl shadow-md w-full max-w-xs border-t-4 border-cf-blue" data-id="element-87">
              <Clock className="w-12 h-12 text-cf-blue mx-auto mb-4" data-id="element-88" />
              <p className="font-bold text-lg" data-id="element-89">✏️ Lo aplicás en clase</p>
            </div>
          </div>

          <div className="text-2xl font-bold text-cf-red mb-10" data-id="element-90">
            <p data-id="element-91">Sin improvisar.</p>
            <p data-id="element-92">Sin empezar desde cero.</p>
          </div>

          <CTAButton text="👉 OBTENER MI MEGAPACK HOY" data-id="element-93" />
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-100 border-y border-gray-200" data-id="element-94">
        <div className="max-w-4xl mx-auto" data-id="element-95">
          <h2 className="md:text-4xl font-black text-center mb-10 text-cf-darkblue text-[23px]" data-id="element-96">
            🧮 ¿QUÉ INCLUYE ESTE MEGA PACK DE MATEMÁTICA SECUNDARIA? ✨📘
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-97">
            <p className="text-lg font-bold mb-6 text-center bg-yellow-100 p-3 rounded" data-id="element-98">
              ✨ Material completo de Matemática para 1° a 6° año, organizado
              por nivel, con teoría y actividades.
            </p>

            <div className="space-y-6" data-id="element-99">
              <div className="flex gap-4" data-id="element-100">
                <div className="text-2xl" data-id="element-101">📘</div>
                <div data-id="element-102">
                  <h4 className="font-bold text-lg" data-id="element-103">1° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-104">
                    números naturales, operaciones básicas, propiedades, sistema
                    decimal, divisibilidad y MCM.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-105">
                <div className="text-2xl" data-id="element-106">📗</div>
                <div data-id="element-107">
                  <h4 className="font-bold text-lg" data-id="element-108">2° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-109">
                    lenguaje algebraico, expresiones algebraicas, términos
                    semejantes, productos notables, factoreo, ecuaciones y
                    función lineal.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-110">
                <div className="text-2xl" data-id="element-111">📙</div>
                <div data-id="element-112">
                  <h4 className="font-bold text-lg" data-id="element-113">3° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-114">
                    números racionales e irracionales, radicación, extracción de
                    factores, radicales semejantes, intervalos y aproximación.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-115">
                <div className="text-2xl" data-id="element-116">📕</div>
                <div data-id="element-117">
                  <h4 className="font-bold text-lg" data-id="element-118">4° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-119">
                    racionalización de denominadores, ecuaciones e inecuaciones
                    con módulo y análisis de funciones.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-120">
                <div className="text-2xl" data-id="element-121">📒</div>
                <div data-id="element-122">
                  <h4 className="font-bold text-lg" data-id="element-123">5° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-124">
                    logaritmos, propiedades, cambio de base, ecuaciones
                    logarítmicas y función exponencial.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-125">
                <div className="text-2xl" data-id="element-126">📓</div>
                <div data-id="element-127">
                  <h4 className="font-bold text-lg" data-id="element-128">6° Año:</h4>
                  <p className="text-gray-700 font-[600]" data-id="element-129">
                    números complejos, operaciones y funciones a trozos.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200" data-id="element-130">
              <p className="font-bold text-center text-cf-blue text-lg mb-2" data-id="element-131">
                📚 Teoría clara, ejemplos resueltos y actividades prácticas.
              </p>
              <p className="text-center text-gray-700 font-[600]" data-id="element-132">
                🎁 Bonos incluidos: Fundamentos de Matemática · Razonamiento
                Matemático · Problemas Matemáticos.
              </p>
            </div>
          </div>

          <div className="mt-10" data-id="element-133">
            <CTAButton text="👉 Acceder ahora con descuento" data-id="element-134" />
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-135">
        <div className="max-w-4xl mx-auto" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-137">
            Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-138">
            <div className="bg-red-50 p-8 rounded-xl border-2 border-red-200 relative" data-id="element-139">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-red-500 text-white font-bold py-1 px-6 rounded-full" data-id="element-140">
                Antes
              </div>
              <ul className="space-y-4 mt-4" data-id="element-141">
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-142">
                  <X className="text-red-500 w-6 h-6" data-id="element-143" /> Improvisación constante
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-144">
                  <X className="text-red-500 w-6 h-6" data-id="element-145" /> Cansancio al planificar
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-146">
                  <X className="text-red-500 w-6 h-6" data-id="element-147" /> Horas extra en casa
                </li>
                <li className="flex items-center gap-3 text-gray-700 font-[500]" data-id="element-148">
                  <X className="text-red-500 w-6 h-6" data-id="element-149" /> Estrés antes de cada
                  clase
                </li>
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-xl border-2 border-green-400 relative shadow-lg transform md:scale-105" data-id="element-150">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-green-500 text-white font-bold py-1 px-6 rounded-full" data-id="element-151">
                Después
              </div>
              <ul className="space-y-4 mt-4" data-id="element-152">
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-153">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-154" /> Clases
                  claras y organizadas
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-155">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-156" /> Material
                  listo para usar
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-157">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-158" /> Más
                  seguridad al explicar
                </li>
                <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-159">
                  <CheckCircle className="text-green-500 w-6 h-6" data-id="element-160" /> Más
                  tranquilidad para enseñar
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 px-4 bg-cf-darkblue text-white" data-id="element-161">
        <div className="max-w-5xl mx-auto" data-id="element-162">
          <div className="text-center mb-12" data-id="element-163">
            <h2 className="text-3xl md:text-5xl font-black text-yellow-400 mb-4" data-id="element-164">
              🎁 Regalos especiales
            </h2>
            <h3 className="text-2xl font-bold" data-id="element-165">BONOS INCLUIDOS HOY</h3>
            <p className="text-xl mt-2 opacity-90" data-id="element-166">(Sin costo adicional)</p>
            <p className="text-xl font-bold bg-red-600 inline-block px-4 py-1 mt-4 rounded animate-pulse" data-id="element-167">
              Añade que estos bonos son gratis por el dia de hoy
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-168">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl flex flex-col" data-id="element-169">
              <div className="bg-cf-blue text-white text-center py-2 font-bold" data-id="element-170">
                HOY: GRATIS
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-171">
                <h4 className="text-xl font-black mb-4 text-cf-darkblue" data-id="element-172">
                  🎁 Bono #1
                </h4>
                <p className="mb-6 flex-1 font-[600]" data-id="element-173">
                  problemas matemáticos, ejercicios cotidianos y soluciones.
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/fi1Mme7T5Hc4cwuWWxPYpL/Diseno_sin_titulo_(3).png" alt="Bono 1" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={handleCheckout} data-id="element-174" />
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl flex flex-col" data-id="element-175">
              <div className="bg-cf-blue text-white text-center py-2 font-bold" data-id="element-176">
                HOY: GRATIS
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-177">
                <h4 className="text-xl font-black mb-4 text-cf-darkblue" data-id="element-178">
                  🎁 Bono #2
                </h4>
                <p className="mb-6 flex-1 font-[600]" data-id="element-179">
                  fichas geometría - algebra- trigonometría. aritmética, teoría
                  y ejercicios listos para usar
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/1BamQoFWBAVBgjCuZdoKy1/Diseno_sin_titulo_(2).png" alt="Bono 2" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={handleCheckout} data-id="element-180" />
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl flex flex-col" data-id="element-181">
              <div className="bg-cf-blue text-white text-center py-2 font-bold" data-id="element-182">
                HOY: GRATIS
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-183">
                <h4 className="text-xl font-black mb-4 text-cf-darkblue" data-id="element-184">
                  🎁 Bono #3
                </h4>
                <p className="mb-6 flex-1 font-[600]" data-id="element-185">
                  Actividades de razonamiento Matemático, practica de resolución
                  de problemas, desarrolla el pensamiento matemático
                </p>
                <img src="https://cdn.magicpatterns.com/uploads/nr7UcePkUip6o7rGf1mFUt/Diseno_sin_titulo_(1).png" alt="Bono 3" className="w-full aspect-square object-cover rounded-lg cursor-pointer hover:scale-105 transition-transform" onClick={handleCheckout} data-id="element-186" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-187">
        <div className="max-w-5xl mx-auto" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-189">
            Lo que dicen nuestros colegas docentes
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-190">
            {[{
            name: 'Silvia, 42 años',
            role: 'Profesora de Secundaria',
            text: '¡Me salvó la vida! Antes pasaba todo el domingo planificando, ahora solo abro el PDF y ya tengo la clase lista. Mis alumnos notan que estoy más relajada.'
          }, {
            name: 'Martín, 35 años',
            role: 'Docente de Matemática',
            text: 'El material de 4to y 5to año es excelente. Los chicos entienden mejor con los ejemplos visuales y yo trabajo menos en casa. Una inversión que vale cada peso.'
          }, {
            name: 'Andrea, 50 años',
            role: 'Profesora de 1° a 3° año',
            text: 'Compré el pack con dudas, pero valió cada centavo. Las actividades de razonamiento son geniales y me ahorran horas de búsqueda en internet.'
          }, {
            name: 'Pablo, 38 años',
            role: 'Docente de Secundaria',
            text: 'Por fin un recurso adaptado a nuestra currícula. Los ejercicios resueltos me ahorran muchísimo tiempo en la corrección. Lo recomiendo 100%.'
          }, {
            name: 'Valeria, 45 años',
            role: 'Profesora de Matemática',
            text: 'Los bonos de geometría son espectaculares. Recomiendo este MegaPack a cualquier colega que quiera recuperar su tiempo libre los fines de semana.'
          }].map((testimonial, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-191">
                <div className="flex text-yellow-400 mb-3" data-id="element-192">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-193" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-194">
                  "{testimonial.text}"
                </p>
                <div data-id="element-195">
                  <p className="font-bold text-gray-900" data-id="element-196">{testimonial.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-197">{testimonial.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* PRICING & URGENCY */}
      <section className="py-16 px-4 bg-gradient-to-b from-blue-700 via-blue-800 to-blue-900 border-t-4 border-orange-500 relative overflow-hidden" data-id="element-198">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-10" data-id="element-199">
          <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-200" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-201" />
        </div>

        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-202">
          {/* Big urgency title */}
          <div className="mb-10" data-id="element-203">
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white font-black px-6 py-2 rounded-full text-sm md:text-base mb-6 animate-pulse shadow-lg" data-id="element-204">
              <Clock className="w-5 h-5" data-id="element-205" />
              ESTA OFERTA SE TERMINA PRONTO
              <Clock className="w-5 h-5" data-id="element-206" />
            </div>

            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-4 leading-none tracking-tight drop-shadow-lg" data-id="element-207">
              🔥 OFERTA POR
              <br data-id="element-208" />
              <span className="text-orange-400" data-id="element-209">TIEMPO LIMITADO</span>
            </h2>

            <p className="text-xl md:text-2xl text-white/90 font-semibold max-w-2xl mx-auto" data-id="element-210">
              Accedé a MegaPack Matemática Secundaria + los 3 Bonos de regalo
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-2xl border-4 border-blue-500 mb-10 text-left" data-id="element-211">
            <h3 className="text-xl font-black mb-6 text-center text-gray-900" data-id="element-212">
              📦 Lo que vas a recibir hoy:
            </h3>

            <ul className="space-y-3 max-w-md mx-auto mb-8" data-id="element-213">
              <li className="flex items-center gap-2 font-medium" data-id="element-214">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-215" /> 6
                cuadernillos de Matemática (1° a 6° año)
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-216">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-217" /> Bono #1
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-218">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-219" /> Bono #2
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-220">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-221" /> Bono #3
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-222">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-223" /> Teoría clara
                + ejercicios resueltos
              </li>
              <li className="flex items-center gap-2 font-medium" data-id="element-224">
                <CheckCircle className="text-green-500 w-5 h-5" data-id="element-225" /> Actividades
                prácticas y material visual
              </li>
            </ul>

            <div className="text-center border-t border-gray-200 pt-8" data-id="element-226">
              <p className="text-xl text-gray-500 line-through mb-2" data-id="element-227">
                Precio regular: $49.990
              </p>
              <p className="text-2xl font-bold text-cf-red mb-2" data-id="element-228">🔥HOY SOLO:</p>
              <p className="text-6xl font-black text-gray-900 mb-8" data-id="element-229">$19.990</p>

              <div className="grid grid-cols-2 gap-4 text-sm font-bold text-gray-600 mb-8 max-w-sm mx-auto" data-id="element-230">
                <div className="flex items-center justify-center gap-1" data-id="element-231">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-232" /> Acceso
                  inmediato
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-233">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-234" /> Un solo
                  pago
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-235">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-236" /> Descarga
                  digital
                </div>
                <div className="flex items-center justify-center gap-1" data-id="element-237">
                  <CheckCircle className="w-4 h-4 text-green-500" data-id="element-238" /> Acceso de
                  por vida
                </div>
              </div>

              <CTAButton text="👉 OBTENER MI MEGAPACK HOY" data-id="element-239" />
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-12 px-4 bg-gray-900 text-white text-center" data-id="element-240">
        <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-241">
          <ShieldCheck className="w-20 h-20 text-yellow-400 mb-6" data-id="element-242" />
          <h2 className="text-3xl font-black mb-4" data-id="element-243">Garantía sin riesgo</h2>
          <p className="text-lg text-gray-300" data-id="element-244">
            Tenés 7 días de garantía. Si el material no cumple tus expectativas,
            te devolvemos el 100% de tu dinero sin hacer preguntas.
          </p>
        </div>
      </section>
    </div>;
}